import React, { Component } from "react";
import { UncontrolledTooltip } from "reactstrap";
import moment from 'moment';
import { type } from "os";
import { fetchData } from "../components/common/networkRequests";

const mobileNumber = /^[0-9]{10}$/;
const panCardNumber = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
const validEmail = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
const adharNumber = /^\d{4}\d{4}\d{4}$/g;



const handleOTPSend = async ({ props, mobile, portal, setmessage, setotpsent, client_url, setusername, setisSendingOTP }) => {
  let x;
  setisSendingOTP(true);
  let { remoteip } = props.parentState;
  // sent OTP.
  setusername ? setusername(mobile) : x = 1;

  if (mobile != 'oro' && mobile != 'oro2' && mobile != 'pcol') {
    let { returned } = await fetchData({ url: `${remoteip}/sendotp`, postData: { username: mobile, portal, client_url }, method: "POST", current: { props } });

    if (returned) {
      let { message, reply, success } = returned;
      if (success) {
        setotpsent(true);
        focusOnElemName("otp");
        setmessage("");
      } else {
        setotpsent(false);
        setmessage(message);
      }
    } else {
      setmessage("Network Error");
    }
  } else {
    setotpsent(true);
    focusOnElemName("otp");
  }
  setisSendingOTP(false);
}


const focusOnElemName = (elemnname) => {
  let currentElem = document.getElementsByName(elemnname);
  if (currentElem && currentElem[0]) {
    currentElem[0].focus();
  }
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

const generateOtherValues = (sendData, pageData) => {
  // let { pageData, openmodals } = this.props.parentState;
  let returnVal = {}
  if (sendData.length != 0) {
    sendData.map(otherfield => {
      if (otherfield.varname) {
        returnVal[otherfield.varname] = getObjectsValue(pageData, otherfield.value);
      } else {
        returnVal[otherfield] = getObjectsValue(pageData, otherfield);
      }
    })
  }
  return returnVal
}

const getObjectsValue = (obj, value) => {
  value.split(".").map(k => ((obj[k] || obj[k] == 0) ? (obj = obj[k]) : (obj = {})));
  return (typeof obj !== "object" || obj instanceof Array) ? obj : "";
};

function currencyCommas(val) {
  let rupees, paise, res;
  if (val) {
    [rupees, paise] = String(val).split(".");
    res = rupees.toString().replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");

    if (paise) {
      res += "." + paise.substr(0, 2);
    } else {
      res += ".00";
    }
  } else {
    res = '0.00';
  }
  return res;
}

// const shouldDisplayComponent = ({ pageData, component, allData }) => {
//   let shouldRender = 1;
//   let conditionalRender = 'no';
//   if (component.parents) {
//     for (let i = 0; i < component.parents.length; i++) {
//       let elem = component.parents[i];
//       let parentVal;
//       let pd=pageData;
//       if (elem.source && elem.source == 'global') {
//         pd=allData;
//       }
//       if(typeof(elem.name)=='string'){
//         parentVal = getObjectsValue(pd, elem.name);
//       }

//       // if(elem.name=='cheque_status'){
//       //   console.log({pageData,parentVal,elem});
//       // }

//       if(elem.match=="equal"){
//         let isequal=elem.name.every(el=>getObjectsValue(pd,el) == getObjectsValue(pd,elem.name[0]));
//         if(elem.reverse){
//           shouldRender = isequal ? 0 : 1;
//         }else{
//           shouldRender = isequal ? 1 : 0;
//         }
//       }
//       else if (
//         elem.reverse &&
//         ((elem.match === "exist" && parentVal) ||
//           (elem.match === "in" && elem.value.indexOf(parentVal) != -1) ||
//           (elem.match === "value" && parentVal == elem.value))
//       ) {
//         shouldRender = 0;
//       } else if (
//         !elem.reverse &&
//         ((elem.match === "exist" && parentVal) ||
//           (elem.match === "value" && parentVal == elem.value))
//       ) {
//         shouldRender = shouldRender * 1;
//       } else if (
//         !elem.reverse &&
//         ((elem.match === "exist" && parentVal) ||
//           (elem.match === "in" &&
//             elem.value.indexOf(parentVal) != -1))
//       ) {
//         shouldRender = shouldRender * 1;
//       } else {
//         if (!elem.reverse) {
//           shouldRender = 0;
//         }
//       }

//       if (shouldRender == 0 && elem.show && (elem.show == 'blank' || elem.show == 'readonly')) {
//         shouldRender = (elem.show == 'readonly') ? 1 : shouldRender * 1;
//         conditionalRender = elem.show;
//       }
//     }
//   }

//   return { shouldRender, conditionalRender };
// };

function getMomentDiff(converted) {
  let currentage
  if (converted) {
    let diffnum = moment(converted).diff(moment(), 'milliseconds');
    let diff = moment.duration(diffnum);
    let inText = " From Now";
    if (diffnum < 0) {
      inText = " Ago";
    }
    currentage = (diff.years() != 0 ? Math.abs(diff.years()) + " Years, " : "") + (diff.months() != 0 ? Math.abs(diff.months()) + " Months, " : "") + (diff.days() != 0 ? Math.abs(diff.days()) + " Days" : "") + inText;
  } else {
    currentage = "";
  }
  return currentage;
}

function statusErrorDisplay(row) {
  let completedPercentage = 0;
  if (row.original && row.original.queries) {
    completedPercentage = String(
      Number(
        (100 * row.original.queries.done) / row.original.queries.tot
      ).toFixed(2)
    );
    // isNaN(completedPercentage) ? completedPercentage = 0 : null;
  }
  // isNaN(parseFloat(completedPercentage)) ? completedPercentage = 0 : null;
  return row.value.indexOf("ERR:") != "-1" && row.original ? (
    <span>
      <span className="showtitle" id={`x${row.original._id._str}`}>
        {row.value.split("ERR:")[0]}
      </span>
      <UncontrolledTooltip
        placement="left"
        target={`x${row.original._id._str}`}
      >
        {"ERROR : " + row.value.split("ERR:")[1]}
      </UncontrolledTooltip>
    </span>
  ) : completedPercentage != 0 ? (
    <span>
      <span className="showtitle" id={`x${row.original._id._str}`}>
        {`${completedPercentage != "100.00" ? completedPercentage + "%" : ""} ${row.value
          }`}
      </span>
      {/* <UncontrolledTooltip
        placement="left"
        target={`x${row.original._id._str}`}
      >
        {`* Partially generated reports are useful when you want to check `}
      </UncontrolledTooltip> */}
    </span>
  ) : (
    <span>{row.value}</span>
  );
}
function add(allVals) {
  let total = 0;
  allVals.map(av => {
    let tot = parseFloat(String(av).replace(/,/g, ""));
    total += !isNaN(tot) ? tot : 0;
  });
  // let ret = toCurrency(total);
  return total;
}

function getUserInfo() {
  return JSON.parse(getCookie('orosession'));
}

function sentenceCase(strval) {

  let tolowcase = strval.toLowerCase()
  let n = tolowcase.split(".");
  let newname = "";
  for (let i = 0; i < n.length; i++) {
    let j = 0;
    while (j < n[i].length) {
      if (n[i].charAt(j) != " ") {
        n[i] = n[i].replace(n[i].charAt(j), n[i].charAt(j).toUpperCase());
        break;
      }
      else
        j++;
    }

    newname = newname.concat(n[i] + ".");
  }
  return newname


}

function toTitleCase(str) {
  return str.replace(
    /\w\S*/g,
    function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
  );
}

function camelCase(strval) {
  let str = strval.toLowerCase()
  return str.replace(/\W+(.)/g, function (match, chr) {
    return chr.toUpperCase();
  });
}

function toDate(val) {
  // moment().format()

  let dateval
  if (val && typeof val == 'number') {
    dateval = moment(String(val), 'YYYYMMDD').format('DD/MM/YYYY')
  } else {
    let dtval = parseInt(moment(new Date(val)).format("YYYYMMDD"));
    dateval = moment(String(dtval), 'YYYYMMDD').format('DD/MM/YYYY')
  }

  return dateval

}

function allDates(param) {
  if (param == "today") {
    return moment();
  } else if ((param == "monthstart")) {
    return moment().startOf("month");
  } else if (param.indexOf('ago')) {
    // 
  }

}

const checkIfFastpathAllowed = async ({ searched, current }) => {
  let { remoteip } = current.props.parentState

  let CBSurl = `${remoteip}/sentry`;
  let url = CBSurl;
  let method = 'post';
  let allSidbarsearch = { searched, dataType: "sidebarsearch" };
  let response = await fetchData({ url, postData: allSidbarsearch, method, current });
  return response;
}

const getRequiredField = ({ shouldProceed, current }) => {
  // let lgs = this.props.liftGlobalState;
  let {
    errorMessages,
    currentPage,
    pageData,
    LocalVars,
    formElements
  } = current.props.parentState;

  currentPage = currentPage.toLowerCase();
  const formDefinition = formElements[currentPage]["form"];

  formDefinition.map(formdef => {

    if (formdef && formdef['subComponents']) {
      formdef['subComponents'].map(subformdef => {
        if (subformdef["name"] && subformdef["isRequired"] == true && (pageData[subformdef['name']] == undefined || pageData[subformdef['name']] == "")) {
          shouldProceed = false;
          let x = current.props.parentState.errorMessages;
          x[subformdef["name"]] = "X";
          current.props.liftGlobalState({ name: 'errorMessages' }, x)
        }
      })
    }
    if (formdef["name"] && formdef["isRequired"] == true && (pageData[formdef['name']] == undefined || pageData[formdef['name']] == "")) {
      shouldProceed = false;
      let x = current.props.parentState.errorMessages;
      x[formdef["name"]] = "X";
      current.props.liftGlobalState({ name: 'errorMessages' }, x)
    }
  });
}

export {
  mobileNumber,
  panCardNumber,
  validEmail,
  adharNumber,
  statusErrorDisplay,
  getObjectsValue,
  add,
  // shouldDisplayComponent,
  currencyCommas,
  getUserInfo,
  sentenceCase,
  toTitleCase,
  camelCase,
  toDate,
  allDates,
  generateOtherValues, getRequiredField, getMomentDiff, checkIfFastpathAllowed,
  focusOnElemName,
  handleOTPSend
};

// let finalTaxData = {
//   Credit: { invoice: 10, tds: 110, gst: 70 },
//   Debit: { invoice: 20, tds: 50, gst: 440 }
// };
// // convert to
// let finalTaxData = [
// {type:"invoice",credit:10,debit:20},
// {type:"tds",credit:110,debit:50},
// {type:"gst",credit:70,debit:440}
// ]
